import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { apiRequest } from "../../utils/api";
import styles from "./index.module.scss";

export default function ReminderPopUp({ activitiesList, ...props }) {
  const [showNotification, setShowNotification] = useState(false);
  const [actionTaken, setActionTaken] = useState(false);
  const history = useHistory();
  const { t } = useTranslation();
  const uid = localStorage.getItem("uid");

  useEffect(() => {
    // Fetch reminders only if actionTaken is false or it's the initial mount
    if (!actionTaken) {
      const today = moment();
      if (parseInt(today.date()) >= 1) {
        getUserreminders();
      }

    }
  }, [actionTaken]);

  useEffect(() => {
    // Set actionTaken state based on local storage when component mounts
    const actionTakenStatus = localStorage.getItem("action_taken");
    if (actionTakenStatus === "true") {
      setActionTaken(true);
    } else {
      setActionTaken(false);
    }
  }, []);

  const handleDismiss = async () => {
    setShowNotification(false);
    setActionTaken(true); // Set actionTaken to true after dismissing the reminder
    localStorage.setItem("action_taken", "true");
    await UpdateUserreminders();
  };

  const handleCreateSession = async () => {
    setShowNotification(false);
    setActionTaken(true); // Set actionTaken to true after creating a session
    localStorage.setItem("action_taken", "true");
    history.push("/sessions/form/new");
    await UpdateUserreminders();
  };

  const getUserreminders = async () => {
    try {
      const currentDate = new Date();
      const response = await apiRequest.get(`/api/user/getUserReminders?uid=${uid}`);
      if (response.status === 200) {
        const data = response.data.data;
        if (data.length > 0) {
          const firstloggedIndate = moment(data[0].first_loggedIn_date);
          localStorage.setItem("firstloggedIndate", firstloggedIndate.format("YYYY-MM-DD"));
          const reminderClosedDate = new Date(data[0].reminder_closed_date);
          if (currentDate >= reminderClosedDate) {
            setShowNotification(false);
          } else {
            setShowNotification(true);
          }
        } else {
          console.error('Data array is empty');
        }
      }
    } catch (error) {
      console.error('Error fetching reminders', error);
    }
  };


  async function UpdateUserreminders() {
    try {
      await apiRequest.put(`/api/user/updateReminder?uid=${uid}&firstloggedIndate=${localStorage.getItem("firstloggedIndate")}`);
    } catch (error) {
      console.error('Error updating reminders', error);
    }
  }

  return (
    <>
      {showNotification && !actionTaken && (
        <div className={styles.notificationBanner}>
          <div style={{ fontSize: '14px' }}>
            <strong>{t("sessionSummary.reminder")}:</strong> {t("sessionSummary.reminderNotification")}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className={styles.createSession} onClick={handleCreateSession}>Create a session now</span>
            <span className={styles.closeIcon} onClick={handleDismiss}>&times;</span>
          </div>
        </div>
      )}
    </>
  );
}